import { EnumBase } from 'hay-core-react';
class PlanoEstiloNavegacaoEnum extends EnumBase {
    constructor() {
        super(
            [
                'main.plano.estilonavegacao.fixa',
                'main.plano.estilonavegacao.dinamica',
            ],
            'main.plano.estilonavegacao.fixa'
        );
    }
}

const instance = new PlanoEstiloNavegacaoEnum();
export default instance;
